"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const translate_1 = require("../../../../@inax/translate");
const motion_1 = require("./../../../motion/src/motion");
const movingDirection_1 = require("./../../../motion/src/domain/movingDirection");
const viewMode_1 = require("../../../motion/src/domain/viewMode");
const converter_1 = require("../../../plc/src/converter");
var LineState;
(function (LineState) {
    LineState[LineState["NotSelected"] = 0] = "NotSelected";
    LineState[LineState["Selecting"] = 1] = "Selecting";
    LineState[LineState["Selected"] = 2] = "Selected";
})(LineState || (LineState = {}));
;
let MotionLineComponent = class MotionLineComponent {
    constructor(_inaxMotion, _inaxTranslate, _cdr) {
        this._inaxMotion = _inaxMotion;
        this._inaxTranslate = _inaxTranslate;
        this._cdr = _cdr;
        this._neededVariables = ["MovingState1", "MovingState2", "Executability1", "Executability2", "NumberOfFinalPosition", "HmiId", "FinalPosition"];
        this._activeDirection = movingDirection_1.MovingDirection.None;
        this._lineState = LineState.NotSelected;
        this._timeToTakeover = 0;
        this.deselect = new core_1.EventEmitter();
    }
    set selectedMotion(value) {
        if (this._selectedMotion != value) {
            this._selectedMotion = value;
            if (value == this.motion)
                this.activateLine();
            else
                this.deactivateLine();
        }
    }
    get selectedMotion() {
        return this._selectedMotion;
    }
    get udtMotion() {
        return this.motion.UdtModiondata;
    }
    get timeToTakeover() { return this._timeToTakeover; }
    get lineState() { return this._lineState; }
    get movingDirection() { return this._activeDirection; }
    get takeoverRequested() { return this.lineState == LineState.Selected && this.timeToTakeover > 0; }
    get currentHmiId() { return this.udtMotion.HmiId; }
    get visibleFinalPositions() {
        return this.motion.FinalPositions.slice(0, this.udtMotion.NumberOfFinalPosition);
    }
    get isSelecting() {
        return this.lineState == LineState.Selecting;
    }
    get isSelected() {
        return this.lineState == LineState.Selected;
    }
    get isMovingToTheRight() {
        return this.movingDirection == movingDirection_1.MovingDirection.Right;
    }
    get isMovingToTheLeft() {
        return this.movingDirection == movingDirection_1.MovingDirection.Left;
    }
    get otherHmi() {
        return !this.isSelected && this.motion.OtherHmiId && !this.motion.MotionIsLocked;
    }
    get isLocked() {
        return this.motion.MotionIsLocked;
    }
    get showTakeoverPanel() {
        return !this.motion.OtherHmiId && this.takeoverRequested;
    }
    get showTakeoverTime() {
        return this.motion.OtherHmiId && this.isSelecting;
    }
    get isLeftButtonDisabled() {
        return ((!this.udtMotion.Executability1 || this.isSelecting || this.motion.MotionIsLocked) && !this.isMovingToTheLeft);
    }
    get isRightButtonDisabled() {
        return ((!this.udtMotion.Executability2 || this.isSelecting || this.motion.MotionIsLocked) && !this.isMovingToTheRight);
    }
    get showExternalContent() {
        return this.isSelected && !this.motion.MotionIsLocked;
    }
    get inViewId() {
        return this.motion.MappingName;
    }
    ngOnInit() {
        //subscribe to the services
        this.createProxy();
    }
    ngOnDestroy() {
        //unsubscribe from the services
        this.disposeSelection();
        this.disposeMoving();
        if (this._changeSubscription)
            this._changeSubscription.unsubscribe();
        if (this._eventProxy)
            this._eventProxy.dispose();
    }
    /**
     * This method will be called if the line selection state changes
     */
    onSelectionChange(isSelected) {
        if (isSelected) {
            this.activateLine();
        }
        else {
            this.deactivateLine();
        }
    }
    /**
     * This method will be called i the line is out of view
     */
    onViewStateChanges(inViewInfo) {
        console.log(`line: ${inViewInfo.id} linestate: ${this.lineState} in View: ${inViewInfo.inView}`);
        if (this.lineState == LineState.NotSelected)
            return;
        if (!inViewInfo.inView) {
            //this is necessary because of double check of angular. 
            setTimeout(() => this.deactivateLine());
        }
    }
    /**
     * This method will be called if one of the moving buttons will be pressed
     */
    onStartMoving(direction) {
        //check selection
        if (this.selectedMotion != null && this.selectedMotion.Id == this.motion.Id) {
            if (this._activeDirection == direction)
                return; // already moving in this direction
            this._activeDirection = direction;
            if (this._activeDirection != movingDirection_1.MovingDirection.None) {
                this.disposeMoving();
                this._movingSubscription = this._inaxMotion.startMoving(this.motion, this.directionNumber(direction))
                    .subscribe((event) => { this.onScriptEvent(event); });
            }
        }
    }
    /**
     * This method will be called if one of the moving buttons will be released
     */
    onStopMoving(direction) {
        if (this.lineState == LineState.NotSelected)
            return;
        this._inaxMotion.stopMoving(this.motion, this.directionNumber(direction));
        this._activeDirection == movingDirection_1.MovingDirection.None;
        this.disposeMoving();
    }
    /**
     * This method will be called if the user clicks the permit takeover button.
     */
    onPermitTakeover() {
        if (this.lineState == LineState.NotSelected)
            return;
        this._inaxMotion.permitTakeover(this.motion);
    }
    /**
     * This method will be called if the user clicks the refuse takeover button.
     */
    onRefuseTakeover() {
        if (this.lineState == LineState.NotSelected)
            return;
        this._inaxMotion.refuseTakeover(this.motion);
    }
    directionNumber(direction) {
        if (this.lineState == LineState.NotSelected)
            return 0;
        return direction == 1 ? 1 : 2;
    }
    createProxy() {
        if (this._eventProxy != null) {
            this._eventProxy.dispose();
            this._eventProxy = null;
        }
        this._eventProxy = this._inaxMotion.createMotionProxy(this.motion, this._neededVariables);
        this._changeSubscription = this._eventProxy.ChangeEvent.subscribe((dce) => this.updateMotionProperties(dce), (error) => {
            console.warn("Attempt to join channel failed!", error);
        });
    }
    activateLine() {
        if (this.lineState == LineState.NotSelected) {
            this._timeToTakeover = 0;
            this.disposeSelection();
            this._lineState = LineState.Selecting;
            this._selectionSubscription = this._inaxMotion.selectMotion(this.motion)
                .subscribe((event) => { this.onScriptEvent(event); });
        }
    }
    deactivateLine() {
        if (this.lineState != LineState.NotSelected) {
            this._timeToTakeover = 0;
            this._lineState = LineState.NotSelected;
            this.selectedMotion = null;
            this.deselect.emit(this.motion);
            this.disposeSelection();
        }
    }
    onScriptEvent(event) {
        if (event.IsFinished) {
            this._activeDirection == movingDirection_1.MovingDirection.None;
            if (event.CallerInfo != null) {
                if (event.CallerInfo.FunctionName == "StartSelection") {
                    this.deactivateLine();
                }
                else if (event.CallerInfo.FunctionName == "StartMoving") {
                    console.log(`StartMoving finished`);
                }
            }
        }
        else if (event.Event != null) {
            for (let i = 0; i < event.Event.Properties.length; i++) {
                let property = event.Event.Properties[i];
                let value = event.Event.Values[i];
                //console.log(`function: ${event.CallerInfo.FunctionName}=>property:${property}=${value}`);
                if (event.CallerInfo != null && event.CallerInfo.FunctionName == "StartSelection") {
                    if ((this.lineState == LineState.Selected || this.lineState == LineState.Selecting) && property == "SelectedSlotId" && value == 0) {
                        this._inaxMotion.signalOngoingSelection(this.motion);
                    }
                    else if (property == "SelectedSlotId_TakeoverTime" && value > -1) {
                        this._timeToTakeover = Math.round(value / 10);
                    }
                }
                else if (event.CallerInfo != null && event.CallerInfo.FunctionName == "StartMoving") {
                    let dir = this.directionNumber(this._activeDirection);
                    if (this.lineState == LineState.Selected && (property == `PressedButton${Number(dir)}SlotId` && value == 0)) {
                        this._inaxMotion.signalOngoingMovement(this.motion, dir);
                        console.log(`signal ongoing!`);
                    }
                }
                else {
                }
            }
        }
    }
    disposeSelection() {
        if (this._selectionSubscription != null && !this._selectionSubscription.closed)
            this._selectionSubscription.unsubscribe();
    }
    disposeMoving() {
        if (this._movingSubscription != null && !this._movingSubscription.closed)
            this._movingSubscription.unsubscribe();
    }
    updateMotionProperties(dce) {
        try {
            let expectedMapping = `${this.motion.Plc}.${this.motion.MappingName}`;
            if (dce.Mapping == expectedMapping) {
                for (let [key, value] of converter_1.Converter.flatten(dce.Data)) {
                    if (key == "MovingState1") {
                        this.udtMotion.MovingState1 = value;
                    }
                    else if (key == "MovingState2") {
                        this.udtMotion.MovingState2 = value;
                    }
                    else if (key == "Executability1") {
                        this.udtMotion.Executability1 = value;
                    }
                    else if (key == "Executability2") {
                        this.udtMotion.Executability2 = value;
                    }
                    else if (key == "NumberOfFinalPosition") {
                        this.udtMotion.NumberOfFinalPosition = value;
                    }
                    else if (key == "HmiId") {
                        this.udtMotion.HmiId = value;
                        this.motion.OtherHmiId = value != 0 && value != this._inaxMotion.HmiId;
                        this._lineState = value == this._inaxMotion.HmiId ? LineState.Selected : LineState.NotSelected;
                    }
                    else if (key.startsWith("FinalPosition")) {
                        let idx = key.substring(key.lastIndexOf(".") + 1);
                        if (idx.length > 0) {
                            let index = Number(idx);
                            if (index >= 0 && index <= 15) {
                                this.motion.FinalPositions[index].PositionFlagged = value;
                            }
                        }
                    }
                }
            }
        }
        catch (error) {
            console.warn(`Error updating data! ${error}`);
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], MotionLineComponent.prototype, "motion", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MotionLineComponent.prototype, "selectedMotion", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], MotionLineComponent.prototype, "viewMode", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], MotionLineComponent.prototype, "deselect", void 0);
MotionLineComponent = __decorate([
    core_1.Component({
        selector: 'motion-line',
        templateUrl: './@inax/motionUi/src/motionLine/motionline.component.html',
        styleUrls: ['./@inax/motionUi/src/motionLine/motionline.component.css']
    }),
    __metadata("design:paramtypes", [motion_1.InaxMotionService,
        translate_1.InaxTranslateService,
        core_1.ChangeDetectorRef])
], MotionLineComponent);
exports.MotionLineComponent = MotionLineComponent;
